import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'spb-radio-button',
  templateUrl: './radio-button.component.html',
})
export class RadioButtonComponent implements OnInit {
  @HostBinding('class.spb-radio-button') hostBaseClass = true;
  @Input() parentForm: FormGroup;
  @Input() uniqueIdentifier: string;
  @Input() selectedOption: string;
  @Input() thumbColor: string;
  @Input() contentStyles: any;
  @Input() radioOptionData: any;
  @Output() emitChangeEvent = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

}
